module.exports = __webpack_public_path__ + "img/3.bab1fbc8.png";